var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('code',{staticStyle:{"width":"100%"}},[_c('pre',{domProps:{"textContent":_vm._s(_vm.result)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }